import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable, map } from "rxjs";
import {
	type CreateUnitInput,
	type DescribeUnitInput,
	type ListUnitInput,
	type Unit,
	type UpdateUnitInput,
} from "src/app/schema";
import { ApiService, CognitoService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class UnitService {
	private readonly _api = inject(ApiService);
	private readonly _cognitoService = inject(CognitoService);
	private readonly _httpClient = inject(HttpClient);

	public describeUnit(unit: DescribeUnitInput): Observable<string> {
		return this._httpClient
			.post<{ description: string }>(
				`${this._api.inventoryApiEndpoint}/units/${unit.id}/describe`,
				unit,
			)
			.pipe(map((response) => response.description));
	}

	public createUnit(unit: CreateUnitInput): Observable<Unit> {
		return this._httpClient.post<Unit>(
			`${this._api.inventoryApiEndpoint}/unit`,
			unit,
		);
	}

	public updateUnit(unit: UpdateUnitInput): Observable<Unit> {
		return this._httpClient.put<Unit>(
			`${this._api.inventoryApiEndpoint}/unit`,
			unit,
		);
	}

	public listUnit(unit: UpdateUnitInput): Observable<Unit> {
		return this._httpClient.post<Unit>(
			`${this._api.inventoryApiEndpoint}/unit/${unit.id}/list`,
			unit,
		);
	}

	public delistUnit(unit: ListUnitInput): Observable<Unit> {
		return this._httpClient.post<Unit>(
			`${this._api.inventoryApiEndpoint}/unit/${unit.id}/delist/${unit.status}`,
			unit,
		);
	}

	public assignUnit(unitId: string, targetUserId: string) {
		return this._httpClient.post<Unit>(
			`${this._api.inventoryApiEndpoint}/unit/${unitId}/assign`,
			{
				newUserId: targetUserId,
				userId: this._cognitoService.user().id,
				organizationId: this._cognitoService.user().organizationId,
			},
		);
	}
}
